import { colorNames } from '@/constants/colors'

export type ApplicationState = {
  type_name: string
  application_state: string
  color: string
  label: string
  index: number
}

export const managerGroups = { HEO_MANAGER: 'heo-manager' }

export const applicationStatesValues = {
  QUALIFICATION: 'pending-qualification',
  APP_SUBMIT: 'pending-app-submit',
  DOC_UPLOAD: 'pending-doc-upload',
  FILE_SETUP: 'pending-file-setup',
  COND_APPROVAL: 'pending-condl-approval-uw',
  IE_DELIVERY: 'pending-ie-delivery',
  IE_INTENT_TO_PROCEED: 'pending-intent-to-proceed',
  ORDER_OUT: 'pending-order-outs',
  THIRD_RD_PARTY_RECEIPTS: 'pending-3rd-party-receipts',
  FINAL_APPROVAL_UW: 'pending-final-approval-uw',
  FINAL_APPROVAL_UAM: 'pending-final-approval-uam',
  ICS_DELIVERY: 'pending-ics-delivery',
  ICS_SIGNATURE: 'pending-ics-signature',
  DOC_DRAW: 'pending-doc-draw',
  SIGNATURE: 'pending-signature',
  ESCROW_DISBURSEMENT: 'pending-escrow-disbursement',
  RECORDING: 'pending-recording',
  CLOSED_WON: 'closed-won',
  CLOSED_LOST: 'closed-lost',
}

export const applicationStates: ApplicationState[] = [
  {
    type_name: 'Qualification',
    application_state: applicationStatesValues.QUALIFICATION,
    color: colorNames.graySolid,
    label: 'Pending Qualification',
    index: 0,
  },
  {
    type_name: 'App Submit',
    application_state: applicationStatesValues.APP_SUBMIT,
    color: colorNames.tropicalBlue,
    label: 'Pending App Submit',
    index: 1,
  },
  {
    type_name: 'Doc Upload',
    application_state: applicationStatesValues.DOC_UPLOAD,
    color: colorNames.azureRadiance,
    label: 'Pending Doc Upload',
    index: 2,
  },
  {
    type_name: 'File Setup',
    application_state: applicationStatesValues.FILE_SETUP,
    color: colorNames.toreaBay,
    label: 'Pending File Setup',
    index: 3,
  },
  {
    type_name: "Cond'l Approval",
    application_state: applicationStatesValues.COND_APPROVAL,
    color: colorNames.studioPurple,
    label: "Pending Cond'l Approval",
    index: 4,
  },
  {
    type_name: 'IE Delivery',
    application_state: applicationStatesValues.IE_DELIVERY,
    color: colorNames.flirt,
    label: 'Pending IE Delivery',
    index: 5,
  },
  {
    type_name: 'IE Intent to Proceed',
    application_state: applicationStatesValues.IE_INTENT_TO_PROCEED,
    color: colorNames.bahamaBlue,
    label: 'Pending Intent to Proceed',
    index: 6,
  },
  {
    type_name: 'Order Out',
    application_state: applicationStatesValues.ORDER_OUT,
    color: colorNames.frenchLilac,
    label: 'Pending Order Outs',
    index: 7,
  },
  {
    type_name: '3rd Party Receipts',
    application_state: applicationStatesValues.THIRD_RD_PARTY_RECEIPTS,
    color: colorNames.lilacBush,
    label: 'Pending 3rd Party Receipts',
    index: 8,
  },
  {
    type_name: 'Final Submission',
    application_state: applicationStatesValues.FINAL_APPROVAL_UW,
    color: colorNames.pinkSalmon,
    label: 'Pending Final Submission',
    index: 9,
  },
  {
    type_name: 'Final Approval',
    application_state: applicationStatesValues.FINAL_APPROVAL_UAM,
    color: colorNames.red,
    label: 'Pending Final Approval',
    index: 11,
  },
  {
    type_name: 'ICS Delivery',
    application_state: applicationStatesValues.ICS_DELIVERY,
    color: colorNames.midnightBlue,
    label: 'Pending ICS Delivery',
    index: 12,
  },
  {
    type_name: 'ICS Signature',
    application_state: applicationStatesValues.ICS_SIGNATURE,
    color: colorNames.portage,
    label: 'Pending ICS Signature',
    index: 13,
  },
  {
    type_name: 'Doc Draw',
    application_state: applicationStatesValues.DOC_DRAW,
    color: colorNames.carrotOrange,
    label: 'Pending Doc Draw',
    index: 14,
  },
  {
    type_name: 'Signature',
    application_state: applicationStatesValues.SIGNATURE,
    color: colorNames.blazeOrange,
    label: 'Pending Signature',
    index: 16,
  },
  {
    type_name: 'Escrow Disbursement',
    application_state: applicationStatesValues.ESCROW_DISBURSEMENT,
    color: colorNames.pizazz,
    label: 'Pending Escrow Disbursement',
    index: 17,
  },
  {
    type_name: 'Recording',
    application_state: applicationStatesValues.RECORDING,
    color: colorNames.greenHaze,
    label: 'Pending Recording',
    index: 18,
  },
  {
    type_name: 'Closed Won',
    application_state: applicationStatesValues.CLOSED_WON,
    color: colorNames.harlequin,
    label: 'Closed Won',
    index: 19,
  },
  {
    type_name: 'Closed Lost',
    application_state: applicationStatesValues.CLOSED_LOST,
    color: colorNames.navyBlue,
    label: 'Closed Lost',
    index: 20,
  },
]

export const DISCLOSURE_STATE = [
  applicationStatesValues.APP_SUBMIT,
  applicationStatesValues.DOC_UPLOAD,
  applicationStatesValues.FILE_SETUP,
  applicationStatesValues.COND_APPROVAL,
  applicationStatesValues.IE_DELIVERY,
  applicationStatesValues.IE_INTENT_TO_PROCEED,
]
